<script setup lang="ts">

const props = defineProps({
  min: {
    type: Number,
    default: -Infinity,
  },
  max: {
    type: Number,
    default: Infinity,
  },
  step: {
    type: Number,
    default: 1,
  },
});

const model = defineModel<number>({
  type: Number,
  default: 0,
});

const emit = defineEmits<{
  (event: 'click', value: number): void;
}>();

const increment = () => {
  if (model.value + props.step > props.max) {
    return;
  }
  model.value += props.step;
  emit('click', model.value);
};

const decrement = () => {
  if (model.value - props.step < props.min) {
    return;
  }
  model.value -= props.step;
  emit('click', model.value);
};

</script>

<template>
  <div class="increment-button">
    <button @click="increment">▲</button>
    <span>{{ (isNaN(model)) ? '-' : model }}</span>
    <button @click="decrement">▼</button>
  </div>
</template>

<style scoped>
.increment-button {
  display: flex;
  align-items: center;
  flex-direction: column;
  background: var(--color-layer-2);
  border-radius: .5rem;
  overflow: hidden;
  border: .125rem solid transparent;

  &:hover,
  :focus-within {
    border-color: var(--main-color);
  }
}
.increment-button button {
  color: var(--white);
  border: none;
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
  cursor: pointer;
}
.increment-button button:hover {
  background-color: var(--main-color);
}
.increment-button span {
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
}
</style>
